import React from "react";

function InputField({ type = "text", placeholder = "", name = "", value="", onChange}) {
    return (
        <>
            <input type={type} className="form-control contact-form" placeholder={placeholder} name={name} value={value} onChange={onChange} required />
        </>
    )
}

export default InputField;